export default __webpack_public_path__ + "static/media/logo2.308ae8fe.png";